import { createAction } from 'redux-actions';

export const setFetchPosOrderError = createAction('SET_FETCH_POS_ORDER_ERROR');

export const removeDeletedPosOrderItem = createAction(
  'REMOVE_DELETED_POS_ORDER_ITEM'
);

export const clearPosOderSavingError = createAction(
  'CLEAR_POS_ORDER_ITEM_SAVING_ERROR'
);
